import PropTypes from "prop-types";

const propTypes = {
  children: PropTypes.node,
  powerWordsPointsText: PropTypes.string,
  __cssFor: PropTypes.object,
};

export const ScoreGraphic = ({ children, powerWordsPointsText, __cssFor }) => {
  const SvgStyles = __cssFor;
  return (
    <svg
      css={SvgStyles}
      width="119"
      height="49"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-label={powerWordsPointsText}
      role="img"
    >
      <title>{powerWordsPointsText}</title>
      <ellipse cx="115" cy="38.5" rx="4" ry="3.5" fill="#CCE1FF" />
      <circle cx="104" cy="38" r="5" fill="#CCE1FF" />
      <ellipse cx="111" cy="33.5" rx="4" ry="3.5" fill="#CCE1FF" />
      <path fill="#CCE1FF" d="M104 36h11v6h-11z" />
      <circle cx="28.5" cy="18.5" r="6.5" fill="#CCE1FF" />
      <circle cx="8.5" cy="17.5" r="8.5" fill="#CCE1FF" />
      <circle cx="19.5" cy="10.5" r="6.5" fill="#CCE1FF" />
      <path fill="#CCE1FF" d="M9 15h20v11H9z" />
      <rect
        x="22"
        y="8"
        width="80"
        height="40"
        rx="8"
        fill="#106FF3"
        stroke="#fff"
        strokeWidth="2"
      />
      <circle cx="105.5" cy="14.5" r="6.5" fill="#CCE1FF" />
      <circle cx="86.5" cy="13.5" r="8.5" fill="#CCE1FF" />
      <circle cx="97.5" cy="6.5" r="6.5" fill="#CCE1FF" />
      <path fill="#CCE1FF" d="M86 11h20v11H86z" />
      {children}
    </svg>
  );
};

ScoreGraphic.propTypes = propTypes;
